import React from 'react';
import { Alert, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';
import { useT } from '../../localization/LocalizationProvider';

export function WaitingPage({ header, assignedLabel, title, message }) {
  const t = useT();
  const resolvedTitle = title || t('Player.Waiting.Title');
  const resolvedMessage = message || t('Player.Waiting.Message');
  return (
    <PlayerCardLayout header={header}>
      <Alert severity="success">{assignedLabel}</Alert>
      <Typography variant="h5">{resolvedTitle}</Typography>
      <Typography>{resolvedMessage}</Typography>
    </PlayerCardLayout>
  );
}
